/* eslint-disable func-names, max-len, no-new, no-underscore-dangle */
const bindPopups = function () {
  const $ShowPopBtn = $('.js-open-popup');
  const $ClosePopBtn = $('.js-close-popup');

  const $FullScreenPop = $('.js-full-screen-popup');

  const active = 'is-active';

  if ($ShowPopBtn.length > 0) {
    $ShowPopBtn.click((event) => {
      const el = $(event.currentTarget);
      const ref = el.data('popup');
      event.preventDefault();

      $FullScreenPop.each((i, item) => {
        const ele = $(item);
        if (ele.data('popup') === ref) {
          ele.addClass(active);
          $('html').addClass('stop-scroll');
          $('html').addClass('full-screen-popup-open');
        }
      });
    });

    $ClosePopBtn.click((event) => {
      const el = $(event.currentTarget);
      event.preventDefault();
      $('html').removeClass('stop-scroll');
      $('html').removeClass('full-screen-popup-open');
      el.closest($FullScreenPop).removeClass(active);
    });
  }
};

$(document).ready(() => {
  bindPopups();
});

const prm = Sys.WebForms.PageRequestManager.getInstance();
prm.add_endRequest(bindPopups);
